export const REQ_MIN_CARS_SUCCESS = "REQ_MIN_CARS_SUCCESS"
export const REQ_MIN_CARS_ERROR = "REQ_MIN_CARS_ERROR"